"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configurations = {
    development: DEVELOPMENT,
    api: API_ENDPOINT,
    log: {
        remoteUrl: LOG_REMOTE_URL,
        level: LOG_LEVEL
    },
    trackingApi: TRACKING_API_ENDPOINT,
    authApi: AUTH_ENDPOINT,
    headerEnrichment: {
        domain: HEADER_ENRICHMENT_DOMAIN,
        customerID: HEADER_ENRICHMENT_CUSTOMER_ID
    },
    mobileIdentityProxyAPI: MOBILE_IDENTITY_PROXY_API,
    blockUserDurationInHours: BLOCK_USER_DURATION_IN_HOURS
};
exports.default = configurations;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFhQSxJQUFNLGNBQWMsR0FBd0I7SUFDeEMsV0FBVyxFQUFFLFdBQVc7SUFDeEIsR0FBRyxFQUFFLFlBQVk7SUFDakIsR0FBRyxFQUFFO1FBQ0QsU0FBUyxFQUFFLGNBQWM7UUFDekIsS0FBSyxFQUFFLFNBQVM7S0FDbkI7SUFDRCxXQUFXLEVBQUUscUJBQXFCO0lBQ2xDLE9BQU8sRUFBRSxhQUFhO0lBQ3RCLGdCQUFnQixFQUFFO1FBQ2QsTUFBTSxFQUFFLHdCQUF3QjtRQUNoQyxVQUFVLEVBQUUsNkJBQTZCO0tBQzVDO0lBQ0Qsc0JBQXNCLEVBQUUseUJBQXlCO0lBQ2pELHdCQUF3QixFQUFFLDRCQUE0QjtDQUN6RCxDQUFBO0FBRUQsa0JBQWUsY0FBYyxDQUFBIn0=